import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useIsTranslationsSplitV2Enabled() {
  const config = useRuntimeConfig()

  const { ffTranslationsSplitV2CountriesEnabled } = config.public.i18n

  const {
    market: { countryCode },
  } = useMarketplace()

  return ffTranslationsSplitV2CountriesEnabled?.includes(countryCode)
}
